module.exports = __webpack_public_path__ + "img/tool.6f723e96.svg";